/* eslint-disable max-len */

import { CreateReservationReq } from './create'
 

export type UpdateReservationReq = CreateReservationReq
// remain_amount/paid_amount бэк добавляет в ответ после folio-пересчёта — для остатка на баре шахматки.
// source_name приходит и для источника, скрытого владельцем в настройках: иначе плашка осталась бы пустой.
export type UpdateReservationRes = CreateReservationReq & {
  pk: number
  remain_amount: string
  paid_amount: string
  source_name?: string
}
  
export const UPDATE_RESERVATION = '/v2/pms/reservations/:pk/'
